import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthenticationService } from "../services/authentication.service";
import { jwtDecode } from 'jwt-decode';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: "root"
})
export class AdminGuard implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private location: Location,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let token: any = this.authService.getToken() || '';
    let decodedToken: any;
    let actualRoute = route.routeConfig?.path;
    
    try {
      decodedToken = jwtDecode(token);            
    } catch (e) {
      this.router.navigateByUrl('login');
      return false;
    }

    if (!token) {
      this.router.navigateByUrl('login');
      return false;
    }

    if (token && !this.authService.isTokenExpired(token) && decodedToken['Role'] == "DIRECTEUR_" + environment.establishment) {
      return true;
    }
    else if (token && !this.authService.isTokenExpired(token) && decodedToken['Role'] == "CPE_" + environment.establishment) {
      let params = this.authService.getTokenParameters();

      if (!state.url.includes('student-rooms') && !state.url.includes('tickets')) {
        return true;
      }
      else if (state.url.includes('student-rooms') && params["CPE_ALL_EST"] === "1") {
        return true
      }
      else if (state.url.includes('tickets') && this.authService.userHasAccessToTicket()) {
        return true
      }
      else {
        this.router.navigateByUrl('login');
        this.authService.clearToken();
        return false;
      }
    }

    else {
      this.router.navigateByUrl('login');
      this.authService.clearToken();
      return false;
    }
  }
}
